import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import coursesService from "../../services/CoursesService";
import { CircularProgress, Typography, Container, Box } from "@mui/material";


 
const CourseDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCourse = async () => {
      try {
        const data = await coursesService.getCourseById(id, navigate);
        setCourse(data);
      } catch (error) {
        console.error("Error cargando el curso:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCourse();
  }, [id, navigate]);

  if (loading) {
    return (
      <Container sx={{ mt: 4, textAlign: "center" }}>
        <CircularProgress />
      </Container>
    );
  }

  if (!course) {
    return (
      <Container sx={{ mt: 4 }}>
        <Typography variant="h5" color="error">
          Curso no encontrado.
        </Typography>
      </Container>
    );
  }

  return (
    <Container sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom>{course.title}</Typography>
      <img
        src={course.thumbnail}
        alt={course.title}
        style={{
          width: "100%",
          maxHeight: 400,
          objectFit: "cover",
          borderRadius: 8
        }}
      />
      <Box mt={3}>
        <Typography variant="body1"><strong>Instructor:</strong> {course.teached_id}</Typography>
        <Typography variant="body1"><strong>Fecha:</strong> {course.createdAt}</Typography>
        <Typography variant="body1"><strong>Descripción:</strong> {course.description}</Typography>
      </Box>
    </Container>
  );
};

export default CourseDetail;
